import purchaseDialogReducer from './purchaseDialogReducer';

export default purchaseDialogReducer;